<template>
  <div :class="{ 'client-eval-page--indiv': isIndiv }">
    <nnav v-if="!isIndiv"></nnav>
    <div class="bgimg">
      <div class="userlist client-eval-accounts">
        <div class="list_head">
          <!-- 搜索 -->
          <div
            class="topTitle"
            v-if="!isIndiv"
            style="margin-left: 40px; padding: 8px 0"
          >
            <img
              style="margin-right: 8px"
              src="../../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px; color: #2c2f37">{{
              type == "console" ? "控制台" : "云服务"
            }}</span
            ><span
              v-if="type == 'console' ? false : true"
              style="color: #868e99; font-size: 14px"
              >&nbsp;>&nbsp;账户列表</span
            >
          </div>

          <ClaimTrial
            v-if="isIndiv && !type"
            @purchase="onClaimTrialPurchase"
            @claimed="onClaimTrialApplied"
          />
          <!-- 账户列表 -->
          <div
            class="contnet"
            :style="{ minHeight: clientEvalMainMinHeight }"
            v-if="!type ? true : false"
          >
            <!-- from=indiv：账户列表顶部 Tab（非控制台时） -->
            <div v-if="isIndiv && !type" class="client-eval-tabbar-el">
              <el-tabs
                v-model="clientAccountTab"
                @tab-click="onClientAccountTabClick"
              >
                <el-tab-pane label="杰宜斯账户" name="jees"></el-tab-pane>
                <el-tab-pane label="CTP直连账户" name="ctp"></el-tab-pane>
                <el-tab-pane label="第三方账户" name="third"></el-tab-pane>
              </el-tabs>
            </div>
            <div v-show="!isIndiv || clientAccountTab === 'jees'">
              <!-- 注意事项 -->
              <div class="client-eval-notice" role="note">
                <img
                  class="client-eval-notice__icon"
                  src="./img/attention.png"
                  alt=""
                  aria-hidden="true"
                />
                <div class="client-eval-notice__content">
                  <div class="client-eval-notice__title">注意事项</div>
                  <p class="client-eval-notice__text">
                    多账户交易期权时，请将已开通期权的账户设置为初始化账户。
                  </p>
                </div>
              </div>
              <div class="search ctp-direct-search">
                <el-button
                  class="client-eval-add-btn"
                  style="margin-right: 0;"
                  icon="el-icon-plus"
                  type="primary"
                  @click="added"
                  >添加</el-button
                >

                <el-select
                  v-model="ServerManageId"
                  class="ctp-direct-search__field"
                  placeholder="私有云名称"
                  clearable
                  filterable
                  popper-class="ctp-direct-search-dropdown"
                  @visible-change="onJeesSearchYunVisibleChange"
                  @change="onJeesSearchServerManageChange"
                >
                  <el-option
                    v-for="(item, index) in yunNameList"
                    :key="String(item.value) + '-' + index"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-model="account"
                  class="ctp-direct-search__field"
                  placeholder="账户"
                  clearable
                  autocomplete="off"
                  @focus="focus_account"
                  @blur="blur_account"
                />
                <el-input
                  v-model="name"
                  class="ctp-direct-search__field"
                  placeholder="姓名"
                  clearable
                  autocomplete="off"
                  @focus="focus_name"
                  @blur="blur_name"
                />
                <el-select
                  v-model="accountType"
                  class="ctp-direct-search__field"
                  placeholder="账户类型"
                  clearable
                  popper-class="ctp-direct-search-dropdown"
                >
                  <el-option
                    v-for="(item, index) in accountTypeList"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <div>
                  <input
                    class="btn"
                    type="button"
                    @click="search"
                    style="background-color: #5b85ff; color: #fff"
                    value="搜索"
                  />
                  <input
                    class="btn"
                    type="reset"
                    @click="reset"
                    style="margin-right: 0px"
                    value="重置"
                  />
                </div>
              </div>
              <!-- 表格 -->
              <div class="table">
                <el-table
                  :data="tableData"
                  border
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="userType"
                    label="查看"
                    align="center"
                    width="140"
                  >
                    <template slot-scope="scope">
                      <!-- v-show="scope.row.userType != 3 ? true : false" -->
                      <p>
                        <span
                          class="decoration"
                          :style="{ color: '#3D6BF1', cursor: 'pointer' }"
                          @click="
                            settlement(
                              scope.row.id,
                              scope.row.userPwd,
                              scope.row.userCode,
                              scope.row.userType,
                              scope.row.serverManageUrl
                            )
                          "
                          >结算单</span
                        ><i style="color: #edf0f6">丨</i
                        ><span
                          class="decoration"
                          :style="{ color: '#3D6BF1', cursor: 'pointer' }"
                          @click="
                            report(
                              scope.row.id,
                              scope.row.userPwd,
                              scope.row.userCode,
                              scope.row.userType,
                              scope.row.serverManageUrl
                            )
                          "
                          >报告</span
                        >
                      </p>
                      <!-- <i
                      :style="{ color: '#5B85FF', cursor: 'pointer',fontSize:'16px' }"
                      v-show="scope.row.userType == 3 ? true : false"
                      class="el-icon-search decoration"
                      @click="
                        report(
                          scope.row.id,
                          scope.row.userPwd,
                          scope.row.userCode,
                          scope.row.userType,
                          scope.row.serverManageUrl
                        )
                      "
                    ></i> -->
                    </template>
                  </el-table-column>
                  <el-table-column prop="serverManageName" label="私有云名称">
                  </el-table-column>
                  <el-table-column prop="userCode" label="登录账户">
                  </el-table-column>
                  <el-table-column prop="userName" label="登录姓名">
                  </el-table-column>
                  <el-table-column prop="userTypeName" label="账户类型">
                  </el-table-column>

                  <el-table-column width="65" label="排序">
                    <template slot-scope="scope">
                      <div class="icon_sort">
                        <span
                          @click="upBtn(scope.row, scope.$index)"
                          :style="{
                            color: scope.$index == 0 ? '#DCDFE6' : '#5b85ff',
                          }"
                          class="iconfont icon-xiangshang4"
                        ></span>
                        <span
                          @click="downBtn(scope.row, scope.$index)"
                          :style="{
                            color:
                              scope.$index == tableData.length - 1
                                ? '#DCDFE6'
                                : '#5b85ff',
                          }"
                          class="iconfont icon-xiangxia4"
                        ></span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column width="110" align="center">
                    <template slot="header">
                      <MarketColumnHeader />
                    </template>
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.market"
                        disabled
                        @click.native="
                          market(
                            scope.row.id,
                            scope.row.userCode,
                            scope.row.market
                          )
                        "
                      >
                      </el-switch>
                    </template>
                  </el-table-column>

                  <el-table-column label="启用账户" width="110" align="center">
                    <template slot-scope="scope">
                      <el-switch
                        disabled
                        v-model="scope.row.visible"
                        @click.native="
                          visible(
                            scope.row.id,
                            scope.row.userCode,
                            scope.row.visible
                          )
                        "
                      >
                      </el-switch>
                    </template>
                  </el-table-column>

                  <el-table-column label="修改密码" width="80" align="center">
                    <template slot-scope="scope">
                      <i
                        :style="{
                          color: '#5B85FF',
                          cursor: 'pointer',
                          fontSize: '18px',
                        }"
                        class="iconfont icon-xiugaimima decoration"
                        @click="editPwd_btn(scope.row)"
                      ></i>
                    </template>
                  </el-table-column>

                  <el-table-column label="编辑" width="62" align="center">
                    <template slot-scope="scope">
                      <i
                        :style="{ color: '#5B85FF', cursor: 'pointer' }"
                        style="font-size: 13px"
                        class="iconfont icon-bianji decoration"
                        @click="edit_btn(scope.row.id)"
                      ></i>
                    </template>
                  </el-table-column>

                  <el-table-column label="删除" width="62" align="center">
                    <template slot-scope="scope">
                      <i
                        @click="
                          deleteItem(
                            scope.row.id,
                            scope.row.userCode,
                            scope.$index
                          )
                        "
                        :style="{ color: '#5B85FF', cursor: 'pointer' }"
                        class="iconfont icon-shanchu decoration"
                      ></i>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 分页 -->
              <div class="page_box">
                <div class="msg_count">
                  共&nbsp;{{ length ? length : "0" }}&nbsp;条
                </div>
                <div class="blank"></div>
                <div class="page">
                  <!-- <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pageLength ? pageLength : 0"
                  @next-click="addPage"
                  @prev-click="reducePage"
                  @current-change="currentPage"
                >
                </el-pagination> -->
                </div>
              </div>
            </div>
            <ctp-direct-account-list
              ref="ctpDirectList"
              class="client-eval-tab-panel"
              v-show="isIndiv && !type && clientAccountTab === 'ctp'"
              @purchase="onClaimTrialPurchase"
            />
            <third-party-account-list
              ref="thirdPartyList"
              class="client-eval-tab-panel"
              v-show="isIndiv && !type && clientAccountTab === 'third'"
              @purchase="onClaimTrialPurchase"
            />
          </div>
          <!-- 控制台 -->
          <div
            class="contnet"
            :style="{ minHeight: consoleContnetMinHeight }"
            v-if="type == 'console' ? true : false"
          >
            <!-- 添加 -->
            <div class="search" @click="show = true">
              <div class="consoleAdd">
                <el-button icon="el-icon-plus" type="primary">添加 </el-button>
              </div>
            </div>
            <div class="box_body">
              <el-row :gutter="10">
                <el-col
                  v-for="(item, index) in consoleList"
                  :key="index"
                  :xs="24"
                  :sm="24"
                  :md="24"
                  :lg="8"
                  :xl="6"
                  ><div class="grid-content bg-purple">
                    <div class="top">
                      <h3>{{ item.serverManageName }}</h3>
                      <!-- 修改 -->
                      <i
                        @click="edit_btn(item.id)"
                        style="font-size: 14px"
                        class="iconfont icon-bianji"
                      ></i>
                      <em style="font-size: 12px; color: #d3dde9">丨</em>
                      <!-- 删除 -->
                      <i
                        @click="consoleDelete(item.id, item.userCode)"
                        class="iconfont icon-shanchu"
                      ></i>
                    </div>
                    <div
                      class="user_msg"
                      @click="
                        consoleAdd(
                          item.id,
                          item.serverManageUrl,
                          item.userCode,
                          item.userPwd
                        )
                      "
                    >
                      <li>
                        <i style="font-size: 14px" class="iconfont icon-17"></i
                        >账户类型：{{ item.userTypeName }}
                      </li>

                      <li>
                        <i
                          style="font-size: 14px"
                          class="iconfont icon-ic_user_platform"
                        ></i
                        ><span>登录账号：{{ item.userCode }}</span>
                      </li>
                      <li>
                        <i
                          style="font-size: 14px"
                          class="iconfont icon-mingcheng"
                        ></i
                        >私有云名称：{{ item.serverManageName }}
                      </li>

                      <li>
                        <i
                          style="
                            font-size: 18px;
                            margin-left: -2px;
                            margin-right: 2px;
                          "
                          class="iconfont icon-time"
                        ></i
                        >创建时间：{{ item.addTime | renderTime }}
                      </li>
                    </div>
                  </div></el-col
                >
              </el-row>
            </div>
          </div>
          <ConsultFloatBar v-if="isIndiv && !type" />
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <!-- 账户列表遮罩层 -->
      <div class="popContainer" v-show="show">
        <div class="add" :style="{ width: '800px' }">
          <span
            class="close iconfont icon-close_round_fill_bold"
            @click="cancel"
          ></span>
          <div class="Top" :style="{ width: '800px' }">添加</div>
          <div class="form_box">
            <div class="form">
              <div class="col">
                <div class="left"><span>*&nbsp;</span> 添加方式</div>
                <div class="right" style="padding-top: 5px">
                  <el-radio v-model="name_c" label="1">私有云名称</el-radio>
                  <el-radio v-model="name_c" label="0">私有云授权码</el-radio>
                </div>
              </div>
              <div class="col">
                <div class="left" v-show="addYun">
                  <span>*&nbsp;</span> 私有云名称
                </div>
                <div class="left" v-show="!addYun">
                  <span>*</span> 私有云授权码
                </div>
                <div class="right" v-show="addYun">
                  <label
                    class="yunName"
                    style="width: 400px; border-radius: 2px"
                  >
                    <span @mousedown="yun_b" ref="ref1">{{
                      Y_Name ? Y_Name : "私有云名称"
                    }}</span
                    ><i @click="yun_b" class="el-icon-arrow-down"></i>
                    <transition name="el-fade-in-linear">
                      <div class="yunName_select" v-show="yunName_b">
                        <!-- <input
                          type="text"
                          @blur="inp_blur_b"
                          style="width: 390px;"
                          v-model = search_Y_Name
                        /> -->
                        <p
                          @click="addName(item.name, item.value)"
                          v-show="!item.selected"
                          v-for="(item, index) in yunNameList"
                          :key="index"
                        >
                          {{ item.name }}
                        </p>

                        <li v-show="yunNameList.length > 0 ? false : true">
                          未找到结果
                        </li>
                      </div>
                    </transition>
                  </label>
                </div>
                <div class="right" v-show="!addYun">
                  <!-- 授权码输入框 -->
                  <el-input v-model="yunCode" placeholder=""></el-input>
                </div>
              </div>
              <div class="col" v-if="type ? false : true">
                <div class="left"><span>*</span> 账户类型</div>
                <div class="right">
                  <el-radio v-model="account_c" label="1">投顾账户</el-radio>
                  <el-radio v-model="account_c" label="3">资金账户</el-radio>
                  <el-radio v-if="!isIndiv" v-model="account_c" label="2"
                    >模拟账户</el-radio
                  >
                </div>
              </div>
              <div class="col">
                <div v-if="!type ? true : false" class="left">
                  <span>*&nbsp;</span>
                  {{
                    account_c == "1"
                      ? "投顾账号"
                      : account_c == "2"
                      ? "模拟账号"
                      : "资金账户"
                  }}
                </div>
                <div v-if="type ? true : false" class="left">
                  <span>*&nbsp;</span> 管理员账号
                </div>
                <div class="right">
                  <el-input
                    v-model="user"
                    placeholder=""
                    @blur="user_blur"
                  ></el-input>
                  <p class="error_msg" v-show="user_show">请填写该字段</p>
                </div>
              </div>
              <div class="col">
                <div class="left"><span>*&nbsp;</span> 登录密码</div>
                <div class="right">
                  <el-input
                    placeholder=""
                    v-model="pwd"
                    show-password
                    @blur="pwd_blur"
                  ></el-input>
                  <p class="error_msg" v-show="pwd_show">请填写该字段</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form_btn">
            <!-- <button type="info" round @click="cancel">取消</button> -->
            <button type="primary" @click="submit">提交</button>
          </div>
        </div>
      </div>
    </transition>
    <!-- 控制台遮罩层 -->
    <transition name="el-fade-in-linear">
      <div class="popContainer" v-show="false">
        <div class="add" style="width: 800px">
          <span
            class="close iconfont icon-close_round_fill_bold"
            @click="console_show = false"
          ></span>

          <div class="Top" style="width: 800px">添加</div>
          <div class="form_box">
            <div class="form">
              <div class="col">
                <div class="left"><span>*</span> 添加方式</div>
                <div class="right" style="padding-top: 5px">
                  <el-radio v-model="name_c" label="1">私有云名称</el-radio>
                  <el-radio v-model="name_c" label="0">私有云授权码</el-radio>
                </div>
              </div>
              <div class="col">
                <div class="left" v-show="addYun">
                  <span>*</span> 私有云名称
                </div>
                <div class="left" v-show="!addYun">
                  <span>*</span> 私有云授权码
                </div>
                <div class="right" v-show="addYun">
                  <label class="yunName">
                    <span @mousedown="yun_b">私有云名称</span
                    ><i @click="yun_b" class="el-icon-arrow-down"></i>
                    <transition name="el-fade-in-linear">
                      <div class="yunName_select" v-show="yunName_b">
                        <input type="text" @blur="inp_blur_b" />
                        <li>未找到结果</li>
                      </div>
                    </transition>
                  </label>
                </div>
                <div class="right" v-show="!addYun">
                  <el-input v-model="yunCode" placeholder=""></el-input>
                </div>
              </div>
              <!-- <div class="col">
                <div class="left"><span>*</span> 账户类型</div>
                <div class="right">
                  <el-radio v-model="account_c" label="3">投顾账户</el-radio>
                  <el-radio v-model="account_c" label="4">资金账户</el-radio>
                </div>
              </div> -->
              <div class="col">
                <div class="left"><span>*</span> 登录账户</div>
                <div class="right">
                  <el-input
                    v-model="user"
                    placeholder=""
                    @blur="user_blur"
                  ></el-input>
                  <p class="error_msg" v-show="user_show">请填写该字段</p>
                </div>
              </div>
              <div class="col">
                <div class="left"><span>*</span> 登录密码</div>
                <div class="right">
                  <el-input
                    placeholder=""
                    v-model="pwd"
                    show-password
                    @blur="pwd_blur"
                  ></el-input>
                  <p class="error_msg" v-show="pwd_show">请填写该字段</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form_btn" style="width: 800px">
            <el-button type="primary" @click="console_submit">提交</el-button>
            <!-- <button class="submit_btn" @click=submit>提交</button> -->
            <!-- <el-button type="info" round @click="console_show = false"
              >取消</el-button
            > -->
            <!-- <button class="cancel_btn" @click=cancel>取消</button> -->
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <!-- 编辑列表遮罩层 -->
      <div class="popContainer" v-show="edit">
        <div class="add" :style="{ width: '600px' }">
          <span
            class="close iconfont icon-close_round_fill_bold"
            @click="edit = false"
          ></span>
          <div class="close" @click="edit = false"></div>
          <div class="Top" :style="{ width: '600px', height: '67px' }">
            编辑
          </div>
          <div
            class="edit_inp"
            :style="{
              fontSize: '14px',
              background: '#fff',
              color: '#444',
              paddingTop: '30px',
            }"
          >
            <label
              for=""
              :style="{
                display: 'flex',
                width: '400px',
                margin: '0 auto',
                height: '40px',
                padding: '10px 0',
              }"
            >
              <span
                :style="{ flex: 1, textAlign: 'center', lineHeight: '40px' }"
                ><span style="color: red">*&nbsp;</span>登录姓名</span
              >
              <input
                :style="{
                  flex: '2.6',
                  height: '30px',
                  marginTop: '3px',
                  border: '1px solid #CCC',
                  padding: '0 10px',
                  borderRadius: '2px',
                }"
                v-model="edit_name"
                type="text"
              />
            </label>
            <label
              for=""
              :style="{
                display: 'flex',
                width: '400px',
                margin: '0 auto',
                height: '40px',
                padding: '10px 0',
              }"
            >
              <span
                :style="{ flex: 1, textAlign: 'center', lineHeight: '40px' }"
                >&nbsp;&nbsp;更新密码</span
              >
              <input
                :style="{
                  flex: '2.6',
                  height: '30px',
                  marginTop: '3px',
                  border: '1px solid #CCC',
                  padding: '0 10px',
                  borderRadius: '2px',
                }"
                v-model="edit_pwd"
                type="password"
              />
            </label>
          </div>
          <div class="form_btn" style="margin-top: 20px; padding-bottom: 60px">
            <!-- <button type="info" round @click="edit = false">取消</button> -->
            <button type="primary" @click="edit_submit">提交</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in-linear">
      <!-- 修改密码遮罩层 -->
      <div class="popContainer" v-show="editPwd">
        <div class="add" :style="{ width: '600px' }">
          <span
            class="close iconfont icon-close_round_fill_bold"
            @click="editPwd = false"
          ></span>
          <div class="close" @click="editPwd = false"></div>
          <div class="Top" :style="{ width: '600px', height: '67px' }">
            修改密码
          </div>
          <div
            class="edit_inp"
            :style="{
              fontSize: '14px',
              background: '#fff',
              color: '#444',
              paddingTop: '30px',
            }"
          >
            <label
              for=""
              :style="{
                display: 'flex',
                width: '400px',
                margin: '0 auto',
                height: '40px',
                padding: '10px 0',
              }"
            >
              <span
                :style="{ flex: 1, textAlign: 'center', lineHeight: '40px' }"
                ><span style="color: red">*&nbsp;</span>登录账户</span
              >
              <input
                :style="{
                  flex: '2.6',
                  height: '30px',
                  marginTop: '3px',
                  border: '1px solid #CCC',
                  padding: '0 10px',
                  borderRadius: '2px',
                }"
                disabled
                v-model="editPwdMsg.userCode"
                type="text"
              />
            </label>

            <label
              for=""
              :style="{
                display: 'flex',
                width: '400px',
                margin: '0 auto',
                height: '40px',
                padding: '10px 0',
              }"
            >
              <span
                :style="{ flex: 1, textAlign: 'center', lineHeight: '40px' }"
                ><span style="color: red">*&nbsp;</span>原密码&emsp;</span
              >
              <input
                :style="{
                  flex: '2.6',
                  height: '30px',
                  marginTop: '3px',
                  border: '1px solid #CCC',
                  padding: '0 10px',
                  borderRadius: '2px',
                }"
                v-model="editPwdMsg.pwd"
                type="password"
              />
            </label>

            <label
              for=""
              :style="{
                display: 'flex',
                width: '400px',
                margin: '0 auto',
                height: '40px',
                padding: '10px 0',
              }"
            >
              <span
                :style="{ flex: 1, textAlign: 'center', lineHeight: '40px' }"
                ><span style="color: red">*&nbsp;</span>新密码&emsp;</span
              >
              <input
                :style="{
                  flex: '2.6',
                  height: '30px',
                  marginTop: '3px',
                  border: '1px solid #CCC',
                  padding: '0 10px',
                  borderRadius: '2px',
                }"
                v-model="editPwdMsg.newPwd"
                type="password"
              />
            </label>
          </div>
          <div class="form_btn" style="margin-top: 20px; padding-bottom: 60px">
            <!-- <button type="info" round @click="edit = false">取消</button> -->
            <button type="primary" @click="editPwd_submit">提交</button>
          </div>
        </div>
      </div>
    </transition>

    <RealnameDialog
      :visible.sync="showRealnameDialog"
      @success="onRealnameSuccess"
    />
    <PlanSelectDialog
      :visible.sync="showPlanDialog"
      :verified="isPurchaseVerified(purchaseRealname)"
      :show-trial-tip="purchaseTrialTip"
      @confirm="onPlanConfirm"
      @realname="onPurchaseRealname"
    />
    <PurchaseAgreementDialog
      :visible.sync="showPurchaseAgreement"
      :submitting="purchasing"
      @agree="onPurchaseAgreementAgree"
    />
    <PayQrDialog
      :visible.sync="showPayQrDialog"
      :order-no="payOrderNo"
      :amount="payAmount"
      :show-trial-tip="purchaseTrialTip"
      @paid="onPurchasePaid"
    />
    <PurchaseSuccessDialog
      :visible.sync="showPurchaseSuccessDialog"
      :show-trial-tip="purchaseSuccessTrialTip"
      :show-renew-tip="purchaseSuccessRenewTip"
      @confirm="onPurchaseSuccessConfirm"
    />
  </div>
</template>

<script>
import nnav from "../../../components/nav/index";
import CtpDirectAccountList from "./ctp_direct/CtpDirectAccountList.vue";
import ThirdPartyAccountList from "./third_party/ThirdPartyAccountList.vue";
import ClaimTrial from "../subscriptionService/claimTrial.vue";
import {
  refreshSubscriptionStatus,
  subscriptionState,
} from "../subscriptionService/subscriptionService";
import realnameDialogMixin from "../realname/realnameDialogMixin";
import purchaseFlowMixin from "../purchaseService/purchaseFlowMixin";
import {
  refreshIndivSession,
  realnameState,
} from "../indivSession/indivSessionService";
import ConsultFloatBar from "@/components/consultFloatBar/index.vue";
import MarketColumnHeader from "./MarketColumnHeader.vue";
import { marketSetInitConfirmOptions } from "./marketConfirm";
// import '@/assets/icon/iconfont.css';
import "@/assets/icon1/iconfont.css";
import "./style.css";
import { isIndivMixin } from '@/utils/isIndiv';
export default {
  name: "eval_jees",
  mixins: [isIndivMixin, realnameDialogMixin, purchaseFlowMixin],
  components: {
    nnav,
    CtpDirectAccountList,
    ThirdPartyAccountList,
    ClaimTrial,
    ConsultFloatBar,
    MarketColumnHeader,
  },
  data() {
    return {
      clientAccountTab: "jees",
      editPwdMsg: {},
      yunNameSearch: "", //私有云名称搜索框
      yunBoder: "",
      accountAdd1: "",
      focus_account1: "",
      focus_name1: "",
      edit_id: "",
      edit_name: "",
      edit_pwd: "",
      edit: false,
      editPwd: false,
      res: "",
      search_Y_Name: "",
      console_show: false,
      type: "",
      yunCode: "",
      user_show: false,
      pwd_show: false,
      addYun: true,
      user: "",
      pwd: "",
      page: 1, //当前分页
      length: "", //账户列表总数
      pageLength: null, //账户列表分页长度
      consoleList: [], //控制台列表
      name_c: "1",
      account_c: "1",
      show: false,
      yunName: false,
      yunName_b: false,
      accountTypeShow: false,
      err_show: true,
      err_show1: true,
      account: "",
      name: "",
      searchData: "",
      accountType: "",
      yun_name: "",
      yunNameList: [], //私有云列表
      tableData: [],
      accountTypeList: ["投顾用户", "模拟用户", "资金账户"],
      yunList: [],
      Y_Name: "", // 选择私有云名称
      ServerManageId: "",
    };
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    renderTime: function (date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "")
        .substr(0, 16);
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.mbMenu) {
        if (!this.$refs.mbMenu.contains(e.target)) {
          // this.mb_menuVisible = false
          this.accountTypeShow = false;
          this.accountAdd1 = "";
        }
      }

      if (this.$refs.ref1) {
        if (!this.$refs.ref1.contains(e.target)) {
          this.yunName_b = false;
        }
      }

      if (this.$refs.ref2) {
        if (!this.$refs.ref2.contains(e.target)) {
          this.yunName = false;
        }
      }
    });
    //判断账户列表还是控制台
    // console.log(document.documentElement.clientHeight )
    function GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      // console.log(window.location.search); //?id=2
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
    if (GetQueryString("type")) {
      this.type = GetQueryString("type");
    }
    //获取多账户列表信息
    let token = JSON.parse(localStorage.getItem("token"));
    // console.log(token, 1);
    if (!this.type) {
      this.pageAxios(); //账户列表分页
      // indiv 订阅状态由 IndivNav bootstrapIndivSession 统一拉取
      // this.$axios({
      //   //账户列表总条数 总分页
      //   method: 'post',
      //   url: '/cloud/eval_jees/list',
      //   params: {
      //     page_no: 1,
      //     size: 10000,
      //     apiToken: token.apiToken,
      //   },
      // }).then((res) => {
      //   // console.log(res);
      //   if (res.data.code == 200) {
      //     this.length = res.data.data.records.length;
      //     this.pageLength = Math.ceil(res.data.data.records.length);
      //   }
      //   // // console.log(this.tableData)
      // });
    }
    if (this.type) {
      this.consoleAxios();
    }
  },
  computed: {
    /** 控制台主内容区 minHeight；from=indiv 时在基准上 +10px（与列表区 contnet 一致） */
    consoleContnetMinHeight() {
      const base = document.documentElement.clientHeight - 149;
      const indivExtra = this.isIndiv ? 10 : 0;
      return `${base + indivExtra}px`;
    },
    /** 个人端账户列表顶部是否展示试用横幅（与 ClaimTrial 展示条件一致） */
    showClientEvalTrialBanner() {
      if (!this.isIndiv || this.type || !subscriptionState.loaded) return false;
      const view = subscriptionState.view;
      return view.claim || view.trialBanner;
    },
    /** 账户列表主内容区 minHeight（与 consoleContnetMinHeight 同基准）；from=indiv 时 +28px；有顶部横幅时再扣除横幅高度 */
    clientEvalMainMinHeight() {
      const base = document.documentElement.clientHeight - 149;
      let indivBoost = this.isIndiv ? 28 : 0;
      if (this.showClientEvalTrialBanner) {
        // 横幅在 .contnet 上方，inner min-height 120px + root 上内边距 2px
        indivBoost -= 128;
      }
      return `${base + indivBoost}px`;
    },
    /** 购买弹窗读取实名状态 */
    purchaseRealname() {
      return realnameState.status;
    },
  },
  methods: {
    /** from=indiv 账户 Tab：切换时刷新对应列表 */
    onClientAccountTabClick(tab) {
      if (!this.isIndiv || this.type) return;
      const name = tab && tab.name;
      if (name === "jees") {
        this.pageAxios();
      } else if (name === "ctp") {
        refreshSubscriptionStatus({ silent: true }).then(() => {
          const ctp = this.$refs.ctpDirectList;
          if (
            ctp &&
            subscriptionState.view.list &&
            typeof ctp.loadCtpList === "function"
          ) {
            ctp.loadCtpList();
          }
        });
      } else if (name === "third") {
        refreshSubscriptionStatus({ silent: true }).then(() => {
          const third = this.$refs.thirdPartyList;
          if (
            third &&
            subscriptionState.view.list &&
            typeof third.loadList === "function"
          ) {
            third.loadList();
          }
        });
      }
    },
    /** 横幅「购买服务」 */
    onClaimTrialPurchase() {
      this.openPurchaseDialog(subscriptionState.status);
    },
    /** 试用领取成功：刷新订阅并加载 CTP/第三方列表 */
    onClaimTrialApplied() {
      refreshIndivSession({ force: true, store: this.$store }).then(() => {
        this.reloadSubscriptionAccountLists();
      });
    },
    /** 实名成功后刷新 indiv 会话 */
    onRealnameSuccess() {
      refreshIndivSession({ force: true, store: this.$store });
    },
    /** 购买支付成功后刷新账户列表（会话已由 purchaseFlowMixin 刷新） */
    onPurchaseSuccess() {
      this.reloadSubscriptionAccountLists();
    },
    /** 刷新 CTP / 第三方列表（订阅状态变更后） */
    reloadSubscriptionAccountLists() {
      const ctp = this.$refs.ctpDirectList;
      if (
        ctp &&
        ctp.subscriptionListVisible &&
        typeof ctp.loadCtpList === "function"
      ) {
        ctp.loadCtpList();
      }
      const third = this.$refs.thirdPartyList;
      if (
        third &&
        third.subscriptionListVisible &&
        typeof third.loadList === "function"
      ) {
        third.loadList();
      }
    },
    pageAxios() {
      let type = "";

      if (this.accountType == "投顾用户") {
        type = "1";
      }
      if (this.accountType == "模拟用户") {
        type = "2";
      }
      if (this.accountType == "资金账户") {
        type = "3";
      }
      let token = JSON.parse(localStorage.getItem("token"));
      this.$axios({
        method: "post",
        url: "/cloud/eval_jees/list",
        params: {
          page_no: 1,
          size: 1000,
          name: this.account,
          userName: this.name,
          userType: type,
          serverManageId: this.ServerManageId,
          apiToken: token.apiToken,
        },
      }).then((res) => {
        console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200) {
          this.length = res.data.data.records.length;

          this.tableData = res.data.data.records;

          this.tableData.forEach((item) => {
            if (this.yunList.indexOf(item.serverManageName) == -1) {
              this.yunList.push(item.serverManageName);
            }
          });
          // console.log(this.yunList)
        }
        // // console.log(this.tableData)
      });
    },
    consoleAxios() {
      this.$axios({
        //控制台列表
        method: "post",
        url: "/cloud/eval_jees/list",
        params: {
          page_no: 1,
          size: 10000,
          type: "console",
          apiToken: this.$store.state.usermsg.apiToken,
        },
      }).then((res) => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200) {
          this.consoleList = res.data.data.records;
        }
        // // console.log(this.tableData)
      });
    },
    consoleAdd(id, Url, userCode, userPwd) {
      //点击控制台列表
      window.open(
        "_blank"
      ).location.href = `https://${Url}/login/doLoginInter.htm?username=${userCode}&password=${userPwd}`;

      // this.$axios.post(
      //   '/cloud/eval_jees/viewRepo',
      //   {id:id,apiToken: this.$store.state.usermsg.apiToken,}
      // ).then(res=>{
      //   // console.log(res)
      //   this.tokenInvalid(res)
      //   if(res.data.code == 200){
      //     window.open(
      //         '_blank'
      //       ).location.href = `https://${Url}/login/doLoginInter.htm?username=${userCode}&password=${userPwd}`;
      //     }else{
      //       this.$alert('验证失败，账号不存在', {
      //     confirmButtonText: '确定',
      //     type: 'error',
      //     center: true,
      //   })
      //     .then(() => {})
      //     .catch(() => {});
      //       window.open(

      //       ).close()
      //     }
      // })
    },
    addPage(e) {
      //分页 下一页
      //  this.page = e
      //  // console.log(this.page)
    },
    reducePage(e) {
      //上一页
      // this.page = e
      // // console.log(this.page)
    },
    currentPage(e) {
      //当前页
      this.page = e;
      this.pageAxios();
      // console.log(this.page);
    },
    upBtn(e, i) {
      //向上
      if (i != 0) {
        console.log(e);
        this.$axios
          .post("/cloud/eval_jees/upSort", {
            id: e.id,
            apiToken: this.$store.state.usermsg.apiToken,
            sort: e.sort,
          })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$message.success(
                (res.data && (res.data.message || res.data.msg)) || "排序成功"
              );
              this.pageAxios();
            }
          });
      }
    },
    downBtn(e, i) {
      //向下
      if (i != this.tableData.length - 1) {
        console.log(e);
        this.$axios
          .post("/cloud/eval_jees/downSort", {
            id: e.id,
            apiToken: this.$store.state.usermsg.apiToken,
            sort: e.sort,
          })
          .then((res) => {
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$message.success(
                (res.data && (res.data.message || res.data.msg)) || "排序成功"
              );
              this.pageAxios();
            }
          });
      }
    },

    added() {
      if (this.isIndiv && this.account_c === "2") {
        this.account_c = "1";
      }
      this.show = true;
    },
    yun(e) {
      //私有云名称按钮

      this.yunName = !this.yunName;
      this.$axios
        .post("/cloud/account_contrast/add_ajax", {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res)
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.yunNameList = res.data.data;
          }
        });
    },
    /** 杰宜斯列表搜索区：与原先展开私有云下拉时相同接口拉取列表 */
    onJeesSearchYunVisibleChange(visible) {
      if (!visible) {
        return;
      }
      this.$axios
        .post("/cloud/account_contrast/add_ajax", {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.yunNameList = res.data.data;
          }
        });
    },
    /** 与原先 yunNameVal 一致：同步展示名与 serverManageId（v-model 已写 ServerManageId） */
    onJeesSearchServerManageChange(val) {
      if (val === "" || val == null) {
        this.yun_name = "";
        return;
      }
      const list = this.yunNameList || [];
      const row = list.find(
        (it) => it.value === val || String(it.value) === String(val)
      );
      if (row) {
        this.yunNameVal(row.name, row.value);
      } else {
        this.yun_name = "";
      }
    },
    yun_b() {
      this.yunName_b = !this.yunName_b;
      this.$axios
        .post("/cloud/account_contrast/add_ajax", {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res)
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.yunNameList = res.data.data;
          }
        });
    },
    accountAdd() {
      //账户类型按钮
      this.accountTypeShow = !this.accountTypeShow;
      this.accountAdd1 = "1px solid #7195FF";
    },

    focus_account() {
      //账户输入框聚焦
      this.focus_account1 = "1px solid #7195FF";
      this.err_show = false;
    },
    focus_name() {
      //姓名输入框聚焦
      this.err_show1 = false;
      this.focus_name1 = "1px solid #7195FF";
    },
    blur_account() {
      //账户输入框失焦
      this.err_show = true;
      this.focus_account1 = "";
    },
    blur_name() {
      //姓名输入框失焦
      this.err_show1 = true;
      this.focus_name1 = "";
    },
    reset() {
      //重置按钮
      this.account = "";
      this.name = "";
      this.accountType = "";
      this.yun_name = "";
      this.ServerManageId = "";
      this.pageAxios();
    },
    accountTypeAdd(item) {
      //选择账户类型
      this.accountType = item;
      this.accountTypeShow = false;
    },
    cancel() {
      this.show = false;
      this.user = "";
      this.pwd = "";
      this.yunCode = "";
      this.ServerManageId = "";
      this.yun_name = "";
      this.Y_Name = "";
    },

    inp_blur() {
      this.yunName = false;
    },
    inp_blur_b() {
      this.yunName_b = false;
    },
    addName(name, value) {
      //选择私有云名称
      this.Y_Name = name;
      this.ServerManageId = value;
    },
    submit() {
      //   this.$axios({
      //     method: 'post',
      //     url: '/cloud/eval_jees/saveNew',
      //     params: {
      //       choice: this.name_c,
      //       type: this.type ? 'console' : '',
      //       userCode: this.user,
      //       userType: this.account_c,
      //       userPwd: this.pwd,
      //       md5Code: this.yunCode,
      //       ServerManageId:this.ServerManageId,
      //       apiToken: this.$store.state.usermsg.apiToken,
      //     },
      //   })
      this.$axios
        .post("/cloud/eval_jees/saveNew", {
          choice: this.name_c,
          type: this.type ? "console" : "",
          userCode: this.user,
          userType: this.account_c,
          userPwd: this.pwd,
          md5Code: this.yunCode,
          ServerManageId: this.ServerManageId,
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.cancel();

            if (this.type) {
              this.consoleAxios();
            } else {
              this.pageAxios();
            }

            // this.$message({
            //   type: 'success',
            //   message: '添加成功!',
            // });
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    console_submit() {},
    user_blur() {
      if (this.user.length == 0) {
        this.user_show = true;
      } else {
        this.user_show = false;
      }
    },
    pwd_blur() {
      if (this.pwd.length == 0) {
        this.pwd_show = true;
      } else {
        this.pwd_show = false;
      }
    },
    deleteItem(id, Code, row) {
      //删除
      let that = this;
      // console.log(row);
      this.$confirm(`确认删除账户“${Code}”吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/cloud/eval_jees/del",
            params: {
              id: id,
              apiToken: this.$store.state.usermsg.apiToken,
            },
          })
            .then((res) => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                that.pageAxios();
                that.length--;
                if (that.tableData.length > 1) {
                  that.pageLength--;
                }
              } else {
                this.$alert("操作失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                })
                  .then(() => {})
                  .catch(() => {});
              }
              // // console.log(this.tableData)
            })
            .catch((err) => {
              // console.log(err);
            });
        })
        .catch(() => {});
    },
    consoleDelete(id, code) {
      this.$confirm(`确认删除账户“${code}”吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/cloud/eval_jees/del",
            params: {
              id: id,
              apiToken: this.$store.state.usermsg.apiToken,
            },
          })
            .then((res) => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.consoleAxios();
              } else {
              }
              // // console.log(this.tableData)
            })
            .catch((err) => {
              // console.log(err);
            });
        })
        .catch(() => {});
    },
    editPwd_submit() {
      //提交修改密码
      if (this.editPwdMsg.pwd) {
        if (this.editPwdMsg.newPwd) {
          this.$axios
            .post("/cloud/eval_jees/updatePassword", {
              id: this.editPwdMsg.id,
              apiToken: this.$store.state.usermsg.apiToken,
              userCode: this.editPwdMsg.userCode,
              userType: this.editPwdMsg.userType,
              originalPassword: this.editPwdMsg.pwd,
              newPassword: this.editPwdMsg.newPwd,
              serverManageUrl: this.editPwdMsg.serverManageUrl,
            })
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.pageAxios();
                this.editPwd = false;
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "success",
                  center: true,
                });
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.$alert("请输入新密码", {
            confirmButtonText: "确定",
            type: "error",
            center: true,
          });
        }
      } else {
        this.$alert("请输入原密码", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
        });
      }
    },

    market(id, userCode, market) {
      //行情账号

      if (market) {
        // console.log(id,this.$store.state.usermsg.apiToken)
        this.$confirm(
          `确认不使用帐户“${userCode}”作为初始化帐户吗？`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$axios
              .post("/cloud/eval_jees/setMarket", {
                id: id,
                apiToken: this.$store.state.usermsg.apiToken,
              })
              .then((res) => {
                console.log(res, 123);
                this.tokenInvalid(res);
                if (res.data.code == 200) {
                  this.pageAxios();
                }
              })
              .catch((err) => {
                // console.log(err)
              });
          })
          .catch(() => {});
      } else {
        this.$confirm(
          `确认设置帐户“${userCode}”为初始化帐户吗？${
            this.isIndiv
              ? '<br/><span style="color:#f56c6c;">注意：杰宜斯、CTP直连账户仅可共用一个初始化账户。</span>'
              : ""
          }`,
          marketSetInitConfirmOptions({
            dangerouslyUseHTMLString: this.isIndiv,
          })
        )
          .then(() => {
            this.$axios
              .post("/cloud/eval_jees/setMarket", {
                id: id,
                apiToken: this.$store.state.usermsg.apiToken,
              })
              .then((res) => {
                // console.log(res)
                this.tokenInvalid(res);
                if (res.data.code == 200) {
                  this.pageAxios();
                }
              })
              .catch((err) => {
                // console.log(err)
              });
          })
          .catch(() => {});
      }
    },
    visible(id, userCode, visible) {
      //启用账号
      if (visible) {
        this.$confirm(
          `确认停用账户“${userCode}”吗？停用会将帐户组关系解绑！停用后需重新登录多账户交易端。`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$axios
              .post("/cloud/eval_jees/setVisible", {
                id: id,
                apiToken: this.$store.state.usermsg.apiToken,
              })
              .then((res) => {
                // console.log(res)
                this.tokenInvalid(res);
                if (res.data.code == 200) {
                  this.pageAxios();
                }
              })
              .catch((err) => {
                // console.log(err)
              });
          })
          .catch(() => {});
      } else {
        this.$confirm(
          `确认启用帐户“${userCode}”吗？启用后需重新登录多账户交易端。`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$axios
              .post("/cloud/eval_jees/setVisible", {
                id: id,
                apiToken: this.$store.state.usermsg.apiToken,
              })
              .then((res) => {
                // console.log(res)
                this.tokenInvalid(res);
                if (res.data.code == 200) {
                  this.pageAxios();
                }
              })
              .catch((err) => {
                // console.log(err)
              });
          })
          .catch(() => {});
      }
    },

    report(uid, userPwd, code, type, url) {
      //报告
      this.$axios({
        method: "post",
        url: "/cloud/eval_jees/viewRepo",
        params: {
          id: uid,
          apiToken: this.$store.state.usermsg.apiToken,
        },
      })
        .then((res) => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            const fromIndiv = this.isIndiv ? "&from=indiv" : "";
            window.open(
              "_blank"
            ).location.href = `/user/eval_jees/view?id=${uid}&linkTo=1&userPwd=${userPwd}&userCode=${code}&userType=${type}&url=${url}${fromIndiv}`;
          } else {
            this.$alert("验证失败，账号不存在", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            })
              .then(() => {})
              .catch(() => {});
            window.open().close();
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    settlement(uid, userPwd, code, type, url) {
      //结算单
      this.$axios({
        method: "post",
        url: "/cloud/eval_jees/viewRepo",
        params: {
          id: uid,
          apiToken: this.$store.state.usermsg.apiToken,
        },
      })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            // let data = res.data.replace('_','/')
            // // console.log(data)
            const fromIndiv = this.isIndiv ? "&from=indiv" : "";
            window.open(
              "_blank"
            ).location.href = `/user/eval_jees/view?id=${uid}&linkTo=2&userPwd=${userPwd}&userCode=${code}&userType=${type}&url=${url}${fromIndiv}`;
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            })
              .then(() => {})
              .catch(() => {});
            window.open().close();
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    editPwd_btn(e) {
      //修改密码
      this.editPwd = true;
      this.editPwdMsg = e;
      console.log(e);
    },
    edit_btn(uid) {
      //编辑

      this.$axios
        .post("/cloud/eval_jees/edit_ajax", {
          id: uid,
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.edit = true;
            this.edit_name = res.data.data.entity.userName;
            this.edit_id = res.data.data.entity.id;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    edit_submit(uid) {
      //提交修改
      if (this.edit_name) {
        this.$axios({
          method: "post",
          url: "/cloud/eval_jees/saveEdit",
          params: {
            id: this.edit_id,
            type: this.type ? "console" : "",
            apiToken: this.$store.state.usermsg.apiToken,
            userName: this.edit_name,
            userPwd: this.edit_pwd,
          },
        })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.pageAxios();
              this.edit = false;
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",

                type: "error",
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      } else {
        this.$alert("请输入登录姓名", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    search() {
      //模糊搜索
      this.pageAxios();
    },
    yunNameVal(name, value) {
      this.yun_name = name;
      this.ServerManageId = value;
    },
  },

  watch: {
    editPwd(e) {
      if (!e) {
        this.editPwdMsg = {};
      }
    },
    tableData() {},
    account() {
      //监听账户输入框
      if (this.account.length > 0) {
        this.err_show = true;
      }
    },
    name() {
      //监听账户
      if (this.name.length > 0) {
        this.err_show1 = true;
      }
    },
    name_c() {
      // console.log(this.name_c);
      if (this.name_c == 1) {
        this.addYun = true;
      }
      if (this.name_c == 0) {
        this.addYun = false;
      }
    },
    yunNameSearch(e) {
      this.yunList.forEach((item) => {
        if (item.indexOf(e)) {
          // console.log(item.indexOf(e))
        }
      });
    },
    search_Y_Name(e) {
      // console.log(e)
      this.yunNameList.forEach((item) => {
        if (item.name.indexOf(e) < 0) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.yunName_select {
  max-height: 300px;
  overflow-y: auto;
}
.client-eval-tabbar-el {
  margin: 0 0px 20px;
}
.client-eval-tabbar-el ::v-deep .el-tabs__header {
  margin-bottom: 0;
}
.client-eval-tabbar-el ::v-deep .el-tabs__content {
  display: none;
}

/* indiv：Tab 下方子面板占满剩余高度，供无权限/加载态垂直居中 */
.client-eval-page--indiv .contnet {
  display: flex;
  flex-direction: column;
}
.client-eval-page--indiv .contnet > .client-eval-tab-panel {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 杰宜斯账户列表搜索区：与 CtpDirectAccountList 的 ctp-direct-search 一致 */
.client-eval-accounts >>> .ctp-direct-search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
}
.client-eval-accounts >>> .ctp-direct-search .ctp-direct-search__field {
  width: 170px;
}
.client-eval-accounts >>> .ctp-direct-search .ctp-direct-search__field .el-input__inner {
  height: 34px;
  line-height: 34px;
}
</style>
<style>
/* 下拉挂 body，与 CTP 直连账户搜索区 el-select 共用 */
.ctp-direct-search-dropdown.el-select-dropdown .el-select-dropdown__wrap {
  max-height: 280px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/index.vue